import { render, staticRenderFns } from "./Fileupload.vue?vue&type=template&id=5147e822&"
import script from "./Fileupload.js?vue&type=script&lang=js&"
export * from "./Fileupload.js?vue&type=script&lang=js&"
import style0 from "./Fileupload.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports